<main >
  <div fxLayout="column" fxLayoutAlign="space-around center">
    <form (ngSubmit)="onCreateUser()" #userCreationForm="ngForm">
      <div class="form-group">
        <!--   <label for="email">Email</label>-->


        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input name="email" matInput type="email" [(ngModel)]="model.email" required>
        </mat-form-field>
        <!--   <input type="email" class="form-control" id="email"
            required
            [(ngModel)]="model.email" name="email">-->

      </div>

      <div class="form-group">
        <!--   <label for="password">Password</label>-->
        <mat-form-field appearance="fill">
          <mat-label>Mot de passe</mat-label>
          <input matInput type="password" name="password" [(ngModel)]="model.password" required>
        </mat-form-field>
    <!--    <input type="text" class="form-control" id="password"
               required
               [(ngModel)]="model.password" name="password">-->

      </div>
      <div *ngIf="data.type != 'sub'" class="form-group">
        <label for="role">Role</label>
        <select  class="form-control" id="role" [(ngModel)]="model.role" name="role">
          <option value="user">user</option>
          <option value="mainuser">mainuser</option>
          <option value="admin">admin</option>
        </select>


      </div>
      <div class="form-group">
        <!-- <label for="displayName">Display name</label>-->

        <mat-form-field appearance="fill">
          <mat-label>Nom de compte</mat-label>
          <input matInput type="text" name="displayName" [(ngModel)]="model.displayName" required>
        </mat-form-field>
        <!-- <input type="text" class="form-control" id="displayName"
          required
          [(ngModel)]="model.displayName" name="displayName">-->

      </div>
      <div class="buttonContainer">


        <button mat-raised-button color="primary" type="submit" class="btn btn-success">Valider</button>
        <button mat-raised-button color="warn" type="button" (click)="onNoClick()">Annuler</button>
      </div>
    </form>
    
  </div>
</main>
